import { useContent } from "../context/ContentContext";
import { useLang } from "../context/LanguageContext";
import { Zap, ArrowRight } from "lucide-react";

export const LastMinuteBanner = () => {
  const { content } = useContent();
  const { t } = useLang();
  const lm = content.lastminute;
  if (!lm?.enabled || !Number(lm.percent)) return null;

  const text = t("banner.lastMinute")
    .replace("{p}", Number(lm.percent))
    .replace("{d}", Number(lm.daysBefore) || 0);

  return (
    <a
      href="#availability"
      data-testid="lastminute-banner"
      className="group flex w-full items-center justify-center gap-2 bg-[#C85A32] px-4 py-2.5 text-center text-sm font-semibold text-white transition-colors hover:bg-[#B04B26]"
    >
      <Zap className="h-4 w-4 shrink-0 fill-[#F3D9B8] text-[#F3D9B8]" />
      <span>{text}</span>
      <ArrowRight className="h-4 w-4 shrink-0 transition-transform group-hover:translate-x-1" />
    </a>
  );
};
